import { COMPARISON_TYPE } from '@/consts/searchKeys';
import { useQueryParam } from '@/hooks/useQueryParam';
import { ComparisonType } from '@/types/comparison';

// Whether the competition-average comparison is the active comparison mode.
export const useIsCompetitionAverageMode = () => {
  const comparisonType = useQueryParam(COMPARISON_TYPE);

  return comparisonType === ComparisonType.CompetitionAverage;
};
